<script>
    import {fade, fly} from 'svelte/transition';
    import app from "../stores/app";
</script>

{#if $app.popup_loader}
    <div class="loader-overlay" transition:fade="{{ duration: 200 }}">
        <div class="loader-box" in:fly="{{ y: -50, duration: 200 }}" out:fly="{{ y: 50, duration: 200 }}">
            <svg version="1.1" id="L2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                 x="0px"
                 y="0px"
                 viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
<circle fill="none" stroke="#888" stroke-width="4" stroke-miterlimit="10" cx="50" cy="50" r="48"/>
                <line fill="none" stroke-linecap="round" stroke="#888" stroke-width="4" stroke-miterlimit="10" x1="50"
                      y1="50" x2="85" y2="50.5">
  <animateTransform
          attributeName="transform"
          dur="2s"
          type="rotate"
          from="0 50 50"
          to="360 50 50"
          repeatCount="indefinite"/>
</line>
                <line fill="none" stroke-linecap="round" stroke="#888" stroke-width="4" stroke-miterlimit="10" x1="50"
                      y1="50" x2="49.5" y2="74">
  <animateTransform
          attributeName="transform"
          dur="15s"
          type="rotate"
          from="0 50 50"
          to="360 50 50"
          repeatCount="indefinite"/>
</line>
</svg>
        </div>
    </div>
{/if}
<style>
    .loader-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9900;
    }

    .loader-box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        border-radius: 50%;
        box-shadow: 0 0 14px -2px rgba(0, 0, 0, 0.70);
        -webkit-box-shadow: 0 0 14px -2px rgba(0, 0, 0, 0.70);
        -moz-box-shadow: 0 0 14px -2px rgba(0, 0, 0, 0.70);
        padding: 10px;
    }

    svg {
        width: 60px;
        height: 60px;
    }
</style>